import { FC } from "react";
import { HiOutlineX } from "react-icons/hi";
import { cn, filterClearBtn } from "@design-system";

export interface ClearFiltersButtonProps {
  onClick: () => void;
  title: string;
  /** Extra classes appended to the base (e.g. "flex-1 md:flex-auto"). */
  className?: string;
}

export const ClearFiltersButton: FC<ClearFiltersButtonProps> = ({
  onClick,
  title,
  className = "",
}) => (
  <button
    onClick={onClick}
    className={cn(filterClearBtn, className)}
    title={title}
  >
    <HiOutlineX className="h-5 w-5" />
  </button>
);
